var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<formly-transclude></formly-transclude>\n<div class=\"my-messages\" ng-messages=\"fc[0].$error\" ng-if=\"fc[0].$invalid && (fc[0].$touched || form.$submitted)\">\n<div class=\"some-message\" ng-message=\"{{::name}}\" ng-repeat=\"(name, message) in ::options.validation.messages\">\n{{message(fc[0].$viewValue, fc[0].$modelValue, this)}}\n</div>\n</div>\n";
var id1="bsserror.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;